import React, { useMemo } from "react";
import { getRuntimeEnv } from "../../../providers/getRuntimeEnv";

export const SyncrosaleLoader = () => {
  const runtimeEnv = useMemo(() => getRuntimeEnv(), []);
  const isDevEnv = runtimeEnv === "dev";

  return (
    <div style={overlayStyle}>
      <img
        src={isDevEnv ? "/icons/logo-dev.svg" : "/icons/logo.svg"}
        alt="Syncrosale loading"
        style={logoStyle}
      />
    </div>
  );
};

const overlayStyle: React.CSSProperties = {
  position: "absolute",
  inset: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  height: "100%",
  pointerEvents: "none",
};

const logoStyle: React.CSSProperties = {
  width: 128,
  height: 128,
  animation: "syncrosale-spin 2s ease-in-out infinite",
  pointerEvents: "auto",
};
